import { defineMessage } from 'react-intl'

import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const genuine: GetCustomerCopyFunc = () => {
  return {
    generateEligibilityQuestionTitle: () =>
      defineMessage({
        defaultMessage: 'Are you an employee of Genuine McCarthy Enterprises or one of its subsidiaries?',
        description: 'Asking if the user is an employee of Genuine McCarthy Enterprises or one of its subsidiaries',
      }),
  }
}
